var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.30217,
    y: 1.30217,
    width: 14.1783,
    height: 16.0044,
    fill: "white",
    stroke: "#4611A7",
    strokeWidth: 1.39566,
    strokeLinejoin: "bevel"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7689 4.09326H3.39575V5.48879H11.7689V4.09326Z",
    fill: "#4611A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67563 6.88452H3.39575V8.28005H9.67563V6.88452Z",
    fill: "#4611A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7689 9.67578H3.39575V11.0713H11.7689V9.67578Z",
    fill: "#4611A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67563 12.4673H3.39575V13.8628H9.67563V12.4673Z",
    fill: "#4611A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.51946,
    y: 4.43425,
    width: 14.1783,
    height: 16.2653,
    fill: "#4611A7",
    stroke: "#4611A7",
    strokeWidth: 1.39566,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3512 7.58325H8.97803V8.97878H17.3512V7.58325Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2579 10.3745H8.97803V11.77H15.2579V10.3745Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3512 13.1658H8.97803V14.5613H17.3512V13.1658Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2579 15.9573H8.97803V17.3528H15.2579V15.9573Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0008 21.4177C21.4397 21.4177 23.4167 19.4407 23.4167 17.0018C23.4167 14.563 21.4397 12.5859 19.0008 12.5859C16.562 12.5859 14.585 14.563 14.585 17.0018C14.585 19.4407 16.562 21.4177 19.0008 21.4177Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22C16.243 22 14 19.757 14 17C14 14.243 16.243 12 19 12C21.757 12 24 14.243 24 17C24 19.757 21.757 22 19 22ZM19 13.1682C16.8855 13.1682 15.1682 14.8855 15.1682 17C15.1682 19.1145 16.8855 20.8318 19 20.8318C21.1145 20.8318 22.8318 19.1145 22.8318 17C22.8318 14.8855 21.1145 13.1682 19 13.1682Z",
    fill: "#4611A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.987 18.7088L18.2787 18.6987L16.9229 17.363L17.6413 16.6446L18.6329 17.6362L20.8994 15.4102L21.6077 16.1286L18.987 18.7088Z",
    fill: "#4611A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIcon);
export default __webpack_public_path__ + "static/media/files-icon.0ab98c9b5bd36b0333cc1e4f89363ccb.svg";
export { ForwardRef as ReactComponent };